// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PROFILE_OF_USER = "Profil u\u017eivatelky";
